import styled from "styled-components";
import {Form} from "react-bootstrap";

export const FormGroup  = styled(Form.Group)`
  margin-bottom: 10px;
  
`
